import React from "react";
import classNames from "classnames";
import styled from 'styled-components';
import { ICardProps } from ".";
import { getImagePath } from "../../utilities/path";
import { AutomationTestIdFeature, AutomationTestIdElementType, createDataTestId } from "../../utilities/automation";
import Picture from "../Picture";
import { getReplacedContent, parseHTML } from "../../utilities/markdown";
import ConditionalWrapper from '../ConditionalWrapper/index';

const SimpleTextPhotoCardContainer = styled.div`
    border: 1px solid #BDB6B4;
    border-radius: 0.111rem;
    background-color: unset;

    .card-text {
        font-weight: 400;
    }
    .card-title-link {
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }

    .card-img-top {
        padding-bottom: 1rem;
        border-bottom: 1px solid #BDB6B4;
        border-radius: unset;
    }

    .card-body {
        padding: 0px;
    }
`;

const SimpleTextPhotoCard = (props: ICardProps) => {
    const { className, editorClassObj, cmsId, cardTitle, cardBody, cardFooter, cardImage, cardAlt, children, href, dataTestId } = props;

    return (
        <SimpleTextPhotoCardContainer data-test-id={dataTestId} data-id={cmsId} className={classNames(className, editorClassObj, 'card')}>
            <div className="card-body d-flex flex-column h-100 p-4">
                <ConditionalWrapper condition={Boolean(href)} wrapper={children => <a href={href}>{children}</a>}>
                    <Picture
                        loading="lazy"
                        className={"card-img-top"}
                        src={getImagePath(cardImage)}
                        alt={cardAlt}
                        dataTestId={createDataTestId({ feature: AutomationTestIdFeature.CARD_DECK, element: AutomationTestIdElementType.IMAGE, specifier: 'card-image' })}
                    />
                </ConditionalWrapper>
                <ConditionalWrapper condition={Boolean(href)} wrapper={children => <a href={href} className="card-title-link">{children}</a>}>
                    <h3 className="card-title mt-3 mb-2" dangerouslySetInnerHTML={{ __html: cardTitle }}></h3>
                </ConditionalWrapper>
                {cardBody && <div className="card-text mb-4">
                    {typeof cardBody === 'string' ? parseHTML(cardBody, 'SimpleTextPhotoCard') : getReplacedContent(cardBody)}
                </div>}
                {cardBody && <div className="mt-auto">
                    {typeof cardFooter === 'string' ? parseHTML(cardFooter, 'SimpleTextPhotoCard') : getReplacedContent(cardFooter)}
                </div>}
            </div>
        </SimpleTextPhotoCardContainer>
    );
};

export default SimpleTextPhotoCard;